import { Card } from 'primereact/card';
import type { Dispatch, SetStateAction } from 'react';
import SwitchButton from '../buttons/SwitchButton';
import Container, {
	Column,
	FlexSpaceBetweenContainer,
} from '../container/Container';
import { CustomText } from '../text/Texts';
import styles from './card.module.css';

type Props = {
	imageUrl: string;
	title: string;
	description: string;
	checked: boolean;
	setChecked: Dispatch<SetStateAction<boolean>>;
	onClick?: () => void;
};

const ProgramCard = ({
	imageUrl,
	title,
	description,
	checked,
	setChecked,
	onClick,
}: Props) => {
	return (
		<Card
			pt={{
				root: { className: "w-full bg-white rounded-[28px] w-full p-0 shadow-none" },
				body: { className: styles.programCardBody },
			}}
			onClick={onClick}
		>
			<Column gap="gap-4">
				<FlexSpaceBetweenContainer>
					<Container className="flex items-center">
						<img
							alt="blue car icon"
							width="32"
							height="32"
							src={imageUrl}
						/>
					</Container>
					<SwitchButton checked={checked} setChecked={setChecked} />
				</FlexSpaceBetweenContainer>
				<CustomText
					text={title}
					className="text-primary text-[20px] font-medium leading-[24px]"
				/>
				{/* //TODO: check text body small */}
				<CustomText
					text={description}
					className="text-black text-[14px] font-normal leading-[20px]"
				/>
			</Column>
		</Card>
	);
};

export default ProgramCard;
